'use client';

import type { FC } from 'react';
import {
    Button,
    buttonVariants,
    Card,
    P,
    Title,
    useToast,
} from '@paypoteam/ui-components';

import ShowMoreContent from './ShowMoreContent';

type IntegrationItemStepsType = {
    number: string;
    title: string;
    subtitle: string;
    code?: string;
    buttonText?: string;
};

export interface IntegrationStepsProps {
    integrationSteps: IntegrationItemStepsType[];
}

const IntegrationSteps: FC<IntegrationStepsProps> = ({ integrationSteps }) => (
    <ol>
        {integrationSteps.map((step, i) => (
            <li key={`integration-step-${i}`}>
                <div className="mb-4 flex flex-wrap items-center">
                    <span className="text-typography-primary relative z-auto flex h-[48px] w-[48px] items-center justify-center rounded-full bg-green-100 font-extrabold leading-none">
                        {step.number}
                    </span>

                    <Title
                        size="m"
                        className="mb-3 ml-4 w-auto sm:mb-0"
                    >
                        {step.title}
                    </Title>
                </div>

                <P
                    size="s"
                    className="mb-4"
                >
                    {step.subtitle}
                </P>

                {step.code && (
                    <Card
                        size={'m'}
                        className="mb-6 w-full"
                    >
                        <Button
                            size="s"
                            variant="outline"
                            className="mb-3 ml-auto whitespace-nowrap"
                            onClick={async () => {
                                try {
                                    await navigator.clipboard.writeText(
                                        step.code ?? '',
                                    );
                                    useToast({
                                        duration: 5000,
                                        hasCloseIcon: true,
                                        title: 'Skopiowano kod.',
                                        variant: 'success',
                                    });
                                } catch (error) {
                                    useToast({
                                        duration: 5000,
                                        hasCloseIcon: true,
                                        title: 'Nie udało się skopiować kodu.',
                                        variant: 'error',
                                    });
                                }
                            }}
                        >
                            {step.buttonText}
                        </Button>

                        <ShowMoreContent
                            lines={20}
                            showMoreLabel="Pokaż cały kod"
                            showLessLabel="Zwiń kod"
                            buttonClassName={buttonVariants({
                                variant: 'ghost',
                            })}
                        >
                            <code className="text-typography-secondary text-xxs mr-4 whitespace-break-spaces font-mono">
                                {step.code}
                            </code>{' '}
                        </ShowMoreContent>
                    </Card>
                )}
            </li>
        ))}
    </ol>
);

export default IntegrationSteps;
